import React, { useEffect, useRef, useState } from "react";
import * as mapHelper from "../actions/mapHelper";
import { getDictionaryValue } from "utils/dictionary";
import scriptLoader from "react-async-script-loader";
import { map } from "lodash";

const MeridianMapInner = (props) => {

  const mapRef = useRef(null);
  const mapLoading = useRef(true);
  const [mapLoaded, setMapLoaded] = useState(false);
  const initialPlacemarksLoaded = useRef(false);
  const floorIdRef = useRef(null);

  useEffect(() => {
    return () => {
      if (mapRef.current) {
        // window.removeEventListener("resize", handleResize);
        mapRef.current.destroy();
        mapRef.current = null;
        delete window["map"];
      }
    }
  }, []);

  useEffect(() => {
    if (props.isScriptLoaded && props.isScriptLoadSucceed && props.floorId && mapLoading.current) {
      mapLoading.current = false;
      initMap();
    }
  }, [props.isScriptLoaded, props.isScriptLoadSucceed, props.floorId]);
    
  useEffect(() => {
    const { floorId } = props;
    if (
      props.isScriptLoaded && 
      props.isScriptLoadSucceed && 
      mapLoaded && mapRef.current &&
      floorId && floorIdRef.current &&
      floorId !== floorIdRef.current
    ) {

      if (floorId  && floorId != mapRef.current?.floor?.id) {
        floorIdRef.current = floorId;
        mapRef.current.update({floorID: floorId});
      }
      return
    }
    floorIdRef.current = floorId;
  }, [
    props.floorId,
    props.isScriptLoaded,
    props.isScriptLoadSucceed,
    mapLoaded
  ]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getID = () => `meridian-map-${props.ID || "1"}`;

  const handleResize = () => {
    if (mapRef?.current?.update) {
      mapRef.current.update();
    }
  };

  const initMap = () => {
    const MeridianSDK = window.MeridianSDK;
    const token = getDictionaryValue("meridian.token.lvm", props.token);
    const floorId = props.floorId;
    if (MeridianSDK) {
      MeridianSDK.init({ api: new MeridianSDK.API({ environment: "production", token }) });
  
      const mapElement = document.getElementById(getID());

      if (mapElement && mapElement.innerHTML !== "") {
        mapElement.innerHTML = "";
      }
      if (!floorId) {
        mapElement.innerHTML = `Floor not found`;
        return;
      }

      mapRef.current = MeridianSDK.createMap(mapElement, {
        locationID: props.locationID,
        floorID: floorId,
        height: props.height || "500px",
        onPlacemarkClick: (data, options) => {
          if (data.uid && data.type_category === "Generic") {
            options.preventDefault();
            props.mapActions.showExhibitorDetails(data.uid, data.custom_4, props.sitecoreContext.itemId);
          }
        },
        onPlacemarksUpdate: (placemarks) => {
          if (!initialPlacemarksLoaded.current) {
            setMapLoaded(true);
            floorIdRef.current = floorId;
            initialPlacemarksLoaded.current = true;
          } else {
          }
        }
      });

      window["map"] = mapRef.current;
    }

  };

  return null;
};

const meridianSrc=(process.env.PUBLIC_URL!==undefined?process.env.PUBLIC_URL:'/dist/las-vegas-market') + "/meridian-sdk.js";

export default scriptLoader(meridianSrc)(MeridianMapInner);
